import styled from 'styled-components';
import { getUrlWithToken } from '../../../../utils/common';

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 24px;
`;

export const MainInfo = styled.div`
  padding-bottom: 48px;
  display: grid;
  grid-template-columns: 45% 1fr;
  gap: 64px;

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 370px;

  video {
    width: 100% !important;
    height: auto !important;
  }

  @media ${(props) => props.theme.device.mobileL} {
    min-height: unset;
  }
`;

export const Image = styled.div`
  width: 100%;
  height: 100%;
  min-height: 370px;
  background: url(${({ src }) => getUrlWithToken(src)});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center right;

  @media ${(props) => props.theme.device.mobileL} {
    min-height: 202px;
  }
`;

export const Users = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px 68px;

  > div {
    height: 52px;
    display: flex;
    align-items: center;

    &:first-child {
      margin-right: 40px;
      padding-right: 40px;
      border-right: 2px solid ${(props) => props.theme.colors.bgSubFooter};
    }
  }

  .btn-recommend {
    margin-left: auto;

    &.recommended svg {
      fill: ${(props) => props.theme.colors.link} !important;
    }
  }

  @media ${(props) => props.theme.device.tabletL} {
    flex-direction: column;
    gap: 12px;
    > div {
      &:first-child {
        margin-right: 0;
        padding-right: 0;
        border-right: none;
      }
    }
    .btn-recommend {
      margin-right: auto;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    padding: 0;
  }
`;

export const Badge = styled.div`
  background-color: ${(props) => props.theme.colors.bgSubFooter};
  width: 54px;
  min-width: 54px;
  height: 54px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;

  svg {
    fill: none;
    stroke: ${(props) => props.theme.colors.white};
  }
`;

export const CircleImagesWrapper = styled.div`
  margin-right: 20px;

  > div {
    margin-left: -18px;
  }
`;

export const SupportBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
  padding: 13px 40px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
  margin-bottom: 48px;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 82px;
    height: 82px;
    border-radius: 100%;
    background: ${(props) => props.theme.colors.iconBg};

    svg {
      stroke-width: 1.5px;
    }
  }

  a {
    margin-left: auto;
  }

  @media ${(props) => props.theme.device.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`;

export const Anticontainer = styled.div`
  @media ${(props) => props.theme.device.mobileL} {
    width: var(--full-width);
    margin-left: -16px;
  }
`;
